module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: '/img/background/1.jpg',
	bg2: '/img/background/2.jpg',
	bg3: '/img/background/3.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'DeepFocus\'s Blog'
}
